export const PRODUCT_DETAIL = 'Product Detail'
export const SPEED_RATING = 'Speed Rating'
export const TREAD_DEPTH = 'Tread Depth'
export const UTQG = 'UTQG'
export const LOAD_INDEX = 'Load Index'
export const PLY_RATING = 'Ply Rating'
export const WARRANTY_MILES = 'Warranty'
export const RUN_FLAT = 'Run Flat'
export const SIZE = 'Tire Size'

export const VISIBLE_SPECS = [
  PRODUCT_DETAIL,
  SPEED_RATING,
  TREAD_DEPTH,
  UTQG,
  LOAD_INDEX,
  PLY_RATING,
  WARRANTY_MILES,
  RUN_FLAT
]

export const DEFAULT_SPEC = { specValue: '' }
